import {
  User,
  History,
  Building2,
  Target,
  FileText,
  Briefcase,
  BookOpen,
  Gavel,
  Mic,
  Search,
} from 'lucide-vue-next'
import { h } from 'vue'
import type { MenuItem } from '../types/navigation'

const createIcon = (Icon: any, props: any = {}) => {
  return () => h(Icon, { class: 'w-4 h-4 text-primary', ...props })
}

export const getDefaultMenuItems = (): MenuItem[] => [
  { name: 'Accueil', key: 'accueil', href: 'https://courdescomptes.bj' },
  { 
    name: 'Présentation', 
    key: 'presentation',
    submenu: [
      { 
        label: "La Présidente", 
        href: "https://courdescomptes.bj/biographie", 
        icon: createIcon(User)
      },
      { 
        label: "Historique", 
        href: "https://courdescomptes.bj/historique", 
        icon: createIcon(History)
      },
      { 
        label: "Organisation", 
        href: "https://courdescomptes.bj/organisation", 
        icon: createIcon(Building2)
      },
      { 
        label: "Missions et valeurs", 
        href: "https://courdescomptes.bj/missions", 
        icon: createIcon(Target)
      },
      { 
        label: "Textes fondamentaux", 
        href: "https://courdescomptes.bj/textes-fondamentaux", 
        icon: createIcon(FileText)
      },
      { 
        label: "Finalité des travaux", 
        href: "https://courdescomptes.bj/finalite-des-travaux", 
        icon: createIcon(Briefcase)
      },
    ]
  },
  { 
    name: 'Publications', 
    key: 'publications',
    submenu: [
      { 
        label: "Rapports", 
        href: "https://courdescomptes.bj/rapports", 
        icon: createIcon(BookOpen)
      },
      { 
        label: "Arrêts", 
        href: "https://courdescomptes.bj/arrets", 
        icon: createIcon(Gavel)
      },
      { 
        label: "Discours et interventions", 
        href: "https://courdescomptes.bj/discours", 
        icon: createIcon(Mic)
      },
      { 
        label: "Recherche avancée", 
        href: "https://courdescomptes.bj/recherche-avancee", 
        icon: createIcon(Search)
      },
    ]
  },
  { name: 'Actualités', key: 'actualites', href: 'https://courdescomptes.bj/actualites' },
  { name: 'Prestations', key: 'prestations', href: 'https://courdescomptes.bj/plateformes' },
]
